import {FC, useState} from "react";
import AppBar from "../molecules/AppBar.tsx";
import SideMenu from "../atoms/SideMenu.tsx";
import {CloseCircleIcon, MenuIcon} from "../atoms/Icon";
import NavigationSection from "../atoms/NavigationSection.tsx";
import NavigationItem from "../atoms/NavigationItem.tsx";
import {useUser} from "../store/userContext.ts";
import {useSite} from "../store/siteContext.ts";

interface Props {
    title?: string;
    backTo?: string;
}

const AppBarWithNavigation: FC<Props> = ({ title, backTo }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const user = useUser()!;
    const site = useSite()!;

    return <AppBar title={title} backTo={backTo}>
        <MenuIcon size={20} onClick={() => setMenuOpen(true)} />
        <SideMenu open={menuOpen}>
            <CloseCircleIcon size={24} onClick={() => setMenuOpen(false)} />
            <NavigationSection title="Site">
                { user.sites.map(s => <NavigationItem key={s.siteId} onClick={() => window.location.href =`/u/dashboard/site/${s.siteId}`}>{s.siteName}</NavigationItem>) }
            </NavigationSection>
            <NavigationSection title="Link">
                <NavigationItem to={`/u/dashboard/site/${site.id}/welcome`}>Share link with team</NavigationItem>
            </NavigationSection>
            <NavigationSection title="Account">
                {/*<NavigationItem to="/u/profile">Profile page</NavigationItem>*/}
                <NavigationItem to="/u/logout">Log out</NavigationItem>
            </NavigationSection>
        </SideMenu>
    </AppBar>
}

export default AppBarWithNavigation